module.exports = __webpack_public_path__ + "img/star-map_backgrounds-watercolor_black.35d3906.webp";